export const isAddressIncompleteMixin = {
    methods: {
        isAddressIncomplete(address) {
          return address.address === '' || address.zipCode === '' || address.city === '' || address.address === undefined || address.zipCode === undefined || address.city === undefined
        }
    }
  }